import React from 'react';
import { Select } from 'antd';

const { Option } = Select;

function BalanceFilter({ setFilter }) {
  const handleFilterChange = (value) => {
    setFilter(prev => ({
      ...prev,
      balanceFilter: value
    }));
  };

  return (
    <Select 
      defaultValue="all" 
      style={{ width: 120, marginRight: 10 }} 
      onChange={handleFilterChange}
    >
      <Option value="all">All</Option>
      <Option value="belowZero">Below 0</Option>
    </Select>
  );
}

export default BalanceFilter;
